import { render, staticRenderFns } from "./ScheduledTransfers.vue?vue&type=template&id=816a77bc"
import script from "./ScheduledTransfers.vue?vue&type=script&lang=js"
export * from "./ScheduledTransfers.vue?vue&type=script&lang=js"
import style0 from "./ScheduledTransfers.vue?vue&type=style&index=0&id=816a77bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports